export * from "@/ui/components/form/InlineForm/InlineForm";
export * from "@/ui/components/form/InlineForm/InlineForm.config";
